import store from '@/store';

const debug = false;
const PREF_INITIAL = 'PREF_INACTIVITY_CHECKER_INITIAL_SECONDS';
const PREF_REMAINING = 'PREF_INACTIVITY_CHECKER_REMAINING_SECONDS';
const TOKEN = 'PREF_JWT_TOKEN';
const LOGIN_TYPE = 'LOGIN_TYPE';
const PLAYER = 'PREF_PLAYER';
const CLERK = 'PREF_CLERK';

let intervalId;

export function startCheckInactivity(seconds) {
  if (debug) console.log('startCheckInactivity for', seconds);
  if (!seconds) return;
  localStorage.setItem(PREF_INITIAL, seconds);
  localStorage.setItem(PREF_REMAINING, seconds);
  setupListeners();

  if (intervalId) {
    clearInterval(intervalId);
  }

  intervalId = setInterval(() => {
    checkInactivityTimePeriodically();
  }, 1000);
}

async function checkInactivityTimePeriodically() {
  let remaining = localStorage.getItem(PREF_REMAINING);
  let initial = localStorage.getItem(PREF_INITIAL);
  initial = parseInt(initial);
  remaining = parseInt(remaining);
  remaining = remaining - 1;
  localStorage.setItem(PREF_REMAINING, remaining);
  if (debug) console.log('initial', initial);
  if (debug) console.log('remaining', remaining);

  if (remaining <= 0) {
    clearInterval(intervalId);
    let res = await store.dispatch('player/logoutAndRefresh', null, {
      root: true,
    });
    
    this.$router.push('/');
    // document.location.href = "/";
  }
}

export function startCheckInactivityAfterReload() {
  let seconds = localStorage.getItem(PREF_INITIAL);
  if (!seconds) return;
  startCheckInactivity(seconds);
}

function setupListeners() {
  document.addEventListener('mousedown', resetTimer, false);
  document.addEventListener('keypress', resetTimer, false);
}

function resetTimer() {
  if (debug) console.log('resetTimer');
  let seconds = localStorage.getItem(PREF_INITIAL);
  if (!seconds) return;
  startCheckInactivity(seconds);
}
